import * as config from "config-api";
import { fetchWithHeaders } from "../../index";
import { videoDetailPageFromContentItem } from "../../fragments/media";
import { HttpError } from "../../../../utils/errors/http";
import { HTTP_BAD_REQUEST } from "../../../../constants/http";
import {
    isMpxId,
    isSourceId,
} from "../../../../utils/dataTransform/ContentItem/library";

const GRAPHQL_BASE_URL = config.getString("Client.contentApi.baseGraphqlURL");

export const videoDetailPageData = (id) => {
    let queryVariables;
    if (isMpxId(id)) {
        queryVariables = {
            mediaId: parseFloat(id),
        };
    } else if (isSourceId(id)) {
        queryVariables = {
            sourceId: id,
        };
    } else {
        return Promise.reject(
            new HttpError(HTTP_BAD_REQUEST, `Bad media id supplied: ${id}`)
        );
    }

    const gqlQuery = videoDetailPageFromContentItem(!!queryVariables.mediaId);

    return fetchWithHeaders(
        GRAPHQL_BASE_URL,
        {
            query: gqlQuery,
            variables: { ...queryVariables },
        },
        { "X-Cache-By-Country": true },
        false
    );
};
